module.exports = __webpack_public_path__ + "img/cloud3.3c443575.png";